import { toUTC } from 'utils/dateTime/converter';
import moment from 'moment';
import { actionType, fieldType } from './enums';

function addDays(date, offset) {
  const value = new Date(date);
  value.setDate(value.getDate() + offset);
  return new Date(value);
}

function distinct(array, key) {
  return [...new Map(array.map(item => [item[key], item])).values()];
}

function intersection(array1, array2) {
  return array1.filter(x => array2.includes(x));
}

function union(array1, array2) {
  return [...new Set([...array1, ...array2])];
}
function handleFilterActions(filterActionsMap, action) {
  if (filterActionsMap.has(action.field_id)) {
    const existingFilterField = filterActionsMap.get(action.field_id);
    if (action.is_dde_filter_values_list_action_cumulative || existingFilterField.rule_id === action.rule_id) {
      // eslint-disable-next-line no-param-reassign
      action.values = union(action.values, existingFilterField.values);
      // eslint-disable-next-line no-param-reassign
      action.values = distinct(action.values, 'value');
      filterActionsMap.set(action.field_id, action);
    }
  } else filterActionsMap.set(action.field_id, action);
}

function isSetAction(type) {
  return type === actionType.SetValuesList || type === actionType.SetDate;
}

function updateMaps(setActionsMap, conditionIdValueMap, currentSetField) {
  setActionsMap.set(currentSetField.fieldId, currentSetField);
  conditionIdValueMap.set(currentSetField.fieldId, currentSetField.valueInternal);
}

function createSetField(action) {
  return {
    fieldId: action.field_id,
    portalFieldId: action.portal_field_id,
    actionType: action.action_type,
    valueInternal: [],
    value: null,
    fieldType: null,
    setVlByAction: null,
    vlPossibleValues: [],
    ruleId: action.rule_id,
    onlyFiltered: false
  };
}

function isProcessSetActions(filterConditions, setActionsMap, triggeredFieldId) {
  const isPresentinSetActions = filterConditions.some(fc => setActionsMap.has(fc.field_id));
  const isTriggeredField = filterConditions.some(fc => triggeredFieldId === fc.field_id);
  return (triggeredFieldId != null && isTriggeredField) || isPresentinSetActions;
}

function getDateTime(date) {
  const today = new Date();
  let hour = today.getHours();
  let minute = today.getMinutes();
  hour = hour < 10 ? `0${hour}` : hour;
  minute = minute < 10 ? `0${minute}` : minute;
  const time = `${hour}:${minute}:00.000`; // Adding current time with 00 seconds and 000 milliseconds to date
  return `${date}T${time}Z`;
}

function getUtcDateTime(date) {
  const today = new Date();
  let hour = today.getUTCHours();
  let minute = today.getUTCMinutes();
  hour = hour < 10 ? `0${hour}` : hour;
  minute = minute < 10 ? `0${minute}` : minute;
  const time = `${hour}:${minute}:00.000`; // Adding current time with 00 seconds and 000 milliseconds to date
  return `${date}T${time}Z`;
}

function getSetDateValue(action) {
  let date = null;
  switch (action.set_date_type) {
    case 'Offset': {
      /* Since current date will be having senconds and milliseconds, 
                split the date and adding current time with 00 seconds and 000 milliseconds to it
                */
      const splitDate = moment().format('YYYY-MM-DD');
      date = action.offset > 0 ? addDays(toUTC(getDateTime(splitDate)), action.offset) : toUTC(getDateTime(splitDate));
      break;
    }
    case 'Specific': {
      if (action.date) {
        /* Since action date will be having some time value, 
                      split the date and adding current time with 00 seconds and 000 milliseconds to it
                      */
        const splitDate = action.date.split('T');
        date = getUtcDateTime(splitDate[0]);
      }
      break;
    }
    default:
      break;
  }

  return date;
}

export function handleSetActions(
  rule,
  isRequiresContentChanged,
  ruleActions,
  triggeredFieldId,
  conditionIdValueMap,
  setActionsMap,
  filterActionsMap,
  fvlFieldsValueMap
) {
  function updateMapInternal(currentSetField, action) {
    // eslint-disable-next-line no-param-reassign
    currentSetField.value = action.values.filter(v => currentSetField.valueInternal.includes(v.value));
    updateMaps(setActionsMap, conditionIdValueMap, currentSetField);
  }
  let existingSetField;
  ruleActions.forEach(action => {
    const processSetActions = isSetAction(action.action_type) && isProcessSetActions(rule.filter_conditions, setActionsMap, triggeredFieldId);
    const currentSetField = createSetField(action);

    switch (action.action_type) {
      case actionType.SetValuesList: {
        if (processSetActions) {
          currentSetField.fieldType = fieldType.ValuesList;
          currentSetField.setVlByAction = actionType.SetValuesList;

          const selectValueIds = action.values.map(v => v.value);
          existingSetField = setActionsMap.has(currentSetField.fieldId) ? setActionsMap.get(currentSetField.fieldId) : null;
          if (existingSetField === null) {
            // eslint-disable-next-line no-param-reassign
            currentSetField.valueInternal = selectValueIds;
            updateMapInternal(currentSetField, action);
          } else if (existingSetField.ruleId === action.rule_id && existingSetField.setVlByAction === actionType.SetValuesList) {
            // eslint-disable-next-line no-param-reassign
            currentSetField.valueInternal = union(selectValueIds, existingSetField.valueInternal);
            // eslint-disable-next-line no-param-reassign
            action.values = union(action.values, existingSetField.value);
            // eslint-disable-next-line no-param-reassign
            action.values = distinct(action.values, 'value');
            updateMapInternal(currentSetField, action);
          } else if (existingSetField.setVlByAction === actionType.FilterValuesList) {
            currentSetField.valueInternal = intersection(
              selectValueIds,
              existingSetField.vlPossibleValues.map(v => v.value)
            );
            if (currentSetField.valueInternal !== null && currentSetField.valueInternal.length === 0) currentSetField.onlyFiltered = true;
            updateMapInternal(currentSetField, action);
          }
        }
        break;
      }
      case actionType.SetDate: {
        if (processSetActions) {
          currentSetField.fieldType = fieldType.Date;
          currentSetField.value = getSetDateValue(action);
          currentSetField.valueInternal = currentSetField.value;

          if (!setActionsMap.has(currentSetField.fieldId)) {
            updateMaps(setActionsMap, conditionIdValueMap, currentSetField);
          }
        }
        break;
      }
      case actionType.FilterValuesList: {
        if (!isRequiresContentChanged) {
          currentSetField.fieldType = fieldType.ValuesList;
          currentSetField.setVlByAction = actionType.FilterValuesList;
          currentSetField.vlPossibleValues = action.values;

          existingSetField = setActionsMap.has(currentSetField.fieldId) ? setActionsMap.get(currentSetField.fieldId) : null;

          handleFilterActions(filterActionsMap, action);

          if (existingSetField === null) {
            if (fvlFieldsValueMap.has(currentSetField.fieldId)) {
              currentSetField.valueInternal = intersection(
                currentSetField.vlPossibleValues.map(v => v.value),
                fvlFieldsValueMap.get(currentSetField.fieldId)
              );
            } else currentSetField.onlyFiltered = true;
            updateMapInternal(currentSetField, action);
          } else if (existingSetField.setVlByAction === actionType.SetValuesList) {
            if (action.is_dde_filter_values_list_action_cumulative) {
              currentSetField.vlPossibleValues = union(currentSetField.vlPossibleValues, existingSetField.vlPossibleValues);
              currentSetField.vlPossibleValues = distinct(currentSetField.vlPossibleValues, 'value');
            }
            currentSetField.valueInternal = intersection(
              currentSetField.vlPossibleValues.map(v => v.value),
              existingSetField.valueInternal
            );
            updateMapInternal(currentSetField, action);
          }
        }
        break;
      }
      default:
        break;
    }
  });
}

export default {
  handleSetActions
};
